function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 6.273c4.675 0 8.985 2.806 12.924 8.334l.398.57c.34.496.34 1.15 0 1.645-4.046 5.906-8.488 8.905-13.322 8.905-4.675 0-8.985-2.806-12.924-8.334l-.398-.57a1.455 1.455 0 010-1.645C6.724 9.272 11.166 6.273 16 6.273zm0 1.454c-4.187 0-8.14 2.604-11.863 7.9l-.26.373.128.184c3.763 5.423 7.759 8.089 11.995 8.089 4.187 0 8.14-2.604 11.863-7.9l.26-.373-.128-.184C24.232 10.393 20.236 7.727 16 7.727zm0 3.546a4.727 4.727 0 110 9.454 4.727 4.727 0 010-9.454zm0 1.454a3.273 3.273 0 100 6.546 3.273 3.273 0 000-6.546z"
});

function SvgShow(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    preserveAspectRatio: "xMidYMid",
    fill: "currentcolor",
    "data-qa": "svg",
    "aria-labelledby": titleId
  }, props), title ? React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

export default SvgShow;